import React from "react"
import PropTypes from "prop-types"
import { Form, Checkbox, Space, Typography, Card } from "antd"
import { useTranslation } from "react-i18next"
import { ExclamationCircleOutlined } from "@ant-design/icons"
import { useDispatch, useSelector } from "react-redux"
import { collectionSelector } from "store/selectors"
import { setClientId } from "store/bookings"
import styles from "./BookingForm.module.css"
const { Text } = Typography

const AlreadyLinkedNotice = ({ form, alertMessage }) => {
  const existingClientsList = useSelector(collectionSelector("bookings.existing_clients_list"))
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const handleExistingClientSelect = (value) => {
    const matchedClient = existingClientsList[0]
    const existing_client = {
      label: matchedClient?.full_name,
      value: matchedClient?.user_id
    }
    const phoneValue = matchedClient?.phone_number ? { fullNumber: matchedClient?.phone_number, countryCode: matchedClient?.country_code } : null
    const existingClietWithPhone = { ...existing_client, phone_number: phoneValue }
    form.setFieldsValue({
      email: matchedClient?.email,
      phone_number: phoneValue,
      existing_client: existingClietWithPhone,
      isExistingClient: value
    })
    dispatch(setClientId(matchedClient?.user_id))
  }

  return (
    <Card className={styles.alreadyLinkError}>
      <div style={{ padding: 0 }}>
        <Space direction="vertical" size={8}>
          <Space>
            <ExclamationCircleOutlined className={styles.errorIcon} />
            <Text>{alertMessage}</Text>
          </Space>
          <Form.Item name="isExistingClient" valuePropName="checked">
            <Checkbox onChange={handleExistingClientSelect}>{t("booking.continue_with_existing_client")}</Checkbox>
          </Form.Item>
        </Space>
      </div>
    </Card>
  )
}
AlreadyLinkedNotice.propTypes = {
  form: PropTypes.object.isRequired,
  alertMessage: PropTypes.string.isRequired
}
export default AlreadyLinkedNotice
